import { ShieldCheckIcon, UserIcon } from '@heroicons/react/24/outline';
import { CompanyUserRole } from '@sc/graphql';

const usersUtilityRoleTiles: Array<{
  role: CompanyUserRole;
  Icon: HeroIconType;
  description: string;
}> = [
  {
    role: CompanyUserRole.admin,
    Icon: ShieldCheckIcon,
    description:
      'Can manage company users, billing, and all knowledge bases, themes and domains.',
  },
  {
    role: CompanyUserRole.member,
    Icon: UserIcon,
    description:
      'Can create and manage knowledge bases, themes and domains — cannot manage other users.',
  },
];

const companyUserRoleDisplayTitles: Record<CompanyUserRole, string> = {
  [CompanyUserRole.accountOwner]: 'Account owner',
  [CompanyUserRole.admin]: 'Admin',
  [CompanyUserRole.member]: 'Member'
};

export const usersUtility = {
  roleTiles: usersUtilityRoleTiles,
  companyUserRoleDisplayTitles
};
